<template>
    <div class="view">
    

      <div class="area"></div>

        <input type="checkbox" class="openMovilMenu" id="openMovilMenu" style="display: none;">
        <label for="openMovilMenu" class="movilBtnMenuInmob movilIconToggle">
          <div class="spinner2 diagonal part-1"></div>
          <div class="spinner2 horizontal"></div>
          <div class="spinner2 diagonal part-2"></div>
        </label>
        <nav class="main-menu mainMenuInmob" id="movilMenu">
            <ul>                  
                <li class="has-subnav" id="HomeInmo" @click="pressElement('HomeInmo')">
                  <router-link to="/homeInmo" class="sublink" >
                    <i class="fa">
                      <svg fill="#ffffff" width="24px" height="24px" viewBox="0 0 52 52" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M50,12.5H2a2,2,0,0,1,0-4H50a2,2,0,0,1,0,4Z"></path><path d="M50,28H2a2,2,0,0,1,0-4H50a2,2,0,0,1,0,4Z"></path><path d="M50,43.5H2a2,2,0,0,1,0-4H50a2,2,0,0,1,0,4Z"></path></g></svg>
                    </i>
                    <span class="nav-text">Inicio</span>
                 </router-link>
                </li>

                <li class="has-subnav" id="BaseClientes" @click="pressElement('BaseClientes')">
                  <router-link to="/inmobiliaria/1" class="sublink">
                    <i class="fa">
                      <svg width="24px" height="24px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14.5 2.49866C14.5 3.60194 11.366 4.49731 7.5 4.49731C3.634 4.49731 0.5 3.60194 0.5 2.49866M14.5 2.49866C14.5 1.39538 11.366 0.5 7.5 0.5C3.634 0.5 0.5 1.39538 0.5 2.49866M14.5 2.49866V12.4922C14.5 13.5955 11.366 14.4908 7.5 14.4908C3.634 14.4908 0.5 13.5956 0.5 12.4923V2.49866M14.5 7.49536C14.5 8.59864 11.366 9.49414 7.5 9.49414C3.634 9.49414 0.5 8.59864 0.5 7.49536" stroke="#ffffff" stroke-linecap="square"></path> </g></svg>
                    </i>
                    <span class="nav-text">Base Clientes</span>
                  </router-link> 
                </li>
                <li class="has-subnav" id="Precalifica" @click="pressElement('Precalifica')">
                  <router-link to="/Precalifica" class="sublink">
                    <i class="fa">
                      <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.288"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9426 1.25H12.0574C14.3658 1.24999 16.1748 1.24998 17.5863 1.43975C19.031 1.63399 20.1711 2.03933 21.0659 2.93414C21.9607 3.82895 22.366 4.96897 22.5603 6.41371C22.75 7.82519 22.75 9.63423 22.75 11.9426V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574V11.9426C1.24999 9.63423 1.24998 7.82519 1.43975 6.41371C1.63399 4.96897 2.03933 3.82895 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.42514 4.56445 3.09825 5.33517 2.92637 6.61358C2.75159 7.91356 2.75 9.62178 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62178 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12C21.25 9.62178 21.2484 7.91356 21.0736 6.61358C20.9018 5.33517 20.5749 4.56445 20.0052 3.9948C19.4355 3.42514 18.6648 3.09825 17.3864 2.92637C16.0864 2.75159 14.3782 2.75 12 2.75C9.62178 2.75 7.91356 2.75159 6.61358 2.92637ZM12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75ZM7.25 12C7.25 9.37665 9.37665 7.25 12 7.25C14.6234 7.25 16.75 9.37665 16.75 12C16.75 14.6234 14.6234 16.75 12 16.75C9.37665 16.75 7.25 14.6234 7.25 12Z" fill="#ffffff"></path> </g></svg>
                    </i>
                    <span class="nav-text">Precalifica</span>
                  </router-link> 
                </li>
                <li class="has-subnav" id="Calculadora" @click="pressElement('Calculadora')">
                  <router-link to="/Calculadora" class="sublink">
                    <i class="fa">
                      <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3.46447 20.5355C4.92893 22 7.28595 22 12 22C16.714 22 19.0711 22 20.5355 20.5355C22 19.0711 22 16.714 22 12C22 7.28595 22 4.92893 20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 16.714 2 19.0711 3.46447 20.5355Z" stroke="#ffffff" stroke-width="1.5"></path> <path d="M18 8.49998H14M18 14.5H14M18 17.5H14M10 8.49999H8M8 8.49999L6 8.49999M8 8.49999L8 6.49998M8 8.49999L8 10.5M9.5 14.5L8.00001 16M8.00001 16L6.50001 17.5M8.00001 16L6.5 14.5M8.00001 16L9.49999 17.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>
                    </i>
                    <span class="nav-text">Calculadora</span>
                  </router-link> 
                </li>              
            </ul>
        </nav>

      <div id='center' class="inmobContent">
        <div class="relative">
          <div class="vx-navbar-wrapper" style="position:fixed;">
    
            <vs-navbar class="navbar-custom navbar-skelton navbarInmob">
                <!-- <input type="checkbox" class="openMovilMenu" id="openMovilMenu" style="display: none;">
                  <label for="openMovilMenu" class="movilIconToggle">
                    <div class="spinner2 diagonal part-1"></div>
                    <div class="spinner2 horizontal"></div>
                    <div class="spinner2 diagonal part-2"></div>
                  </label> -->
              <div :text="'Botón de inicio'" class="logo-position">
                <div class="flex flex-row headerLogoInmob">
                  <a class="col header-logo alinear-logos" @click="$router.push('/homeInmo'), pressElement('HomeInmo')">
                    <img  src="../../assets/iconos/Logo_solo.png" alt="logo-soc" />
                  </a>
                  <span class="col headerLogoSec">
                    <!--<img class="header-Co-brand" src="../../assets/images/pages/logo-soc.png" alt="logo-soc">-->
                    <img v-if="activeUserInfo.Imagen" class="header-Co-brand" :src="'https://cotizador.socasesores.com/uploads/'+ activeUserInfo.Imagen" :alt="logo-soc">
                  </span>
                </div>
                <img class="headerLogoFraseInmob" src="../../assets/iconos/Frase_solo.png" alt="logo-soc" />
              </div>
              <vs-spacer />
    
              <div class="perfil" :text="'Menú para el perfil'" position="bottom">
                <profile-drop-down />
              </div>
            </vs-navbar>
          </div>
        </div>
        <div class="wrap-all-the-things wrp-inmob" id="wrap-all">
            <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" v-on:actualiza_panel="updatePanel"/>
        </div>   
    
      </div>
    
    </div>
    </template>
    
    
    <script>
    import Logout      from "@/layouts/components/navbar/components/Logout.vue"
    import BackToTop           from 'vue-backtotop'
    import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
    import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
    import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
    import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
    import TheFooter           from '@/layouts/components/TheFooter.vue'
    import themeConfig         from '@/../themeConfig.js'
    import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
    import ProfileDropDown      from "@/layouts/components/navbar/components/ProfileDropDownInmo.vue"
    import grafica2  from '@/views/CasoInmobiliaria/nuevasVistas/grafica2.vue'

    
    
    export default {
       //router: {
       // linkActiveClass: 'active-sublink'
      //},
      components: {
        Logout,
        BackToTop,
        HNavMenu,
        TheFooter,
        TheNavbarHorizontal,
        TheNavbarVertical,
        VNavMenu,
        ProfileDropDown,
        grafica2
      },
      data() {
        return {
          footerType        : themeConfig.footerType  || 'static',
          hideScrollToTop   : themeConfig.hideScrollToTop,
          isNavbarDark      : false,
          navbarColor       : themeConfig.navbarColor || '#fff',
          navbarType        : themeConfig.navbarType  || 'floating',
          navMenuItems      : navMenuItems,
          routerTransition  : themeConfig.routerTransition || 'none',
          routeTitle        : this.$route.meta.pageTitle,          
        }
      },
      watch: {
        "$route"() {
          this.routeTitle = this.$route.meta.pageTitle
        },
        isThemeDark(val) {
          const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
          this.updateNavbarColor(color)
        },
        "$store.state.mainLayoutType"(val) {
          this.setNavMenuVisibility(val)
        }
      },
      computed: {
        bodyOverlay() { return this.$store.state.bodyOverlay },
        contentAreaClass() {
          if(this.mainLayoutType === "vertical") {
            if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
            else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
            else return "content-area-full"
          }
          // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
          else return "content-area-full"
        },
        footerClasses() {
          return {
            'footer-hidden': this.footerType == 'hidden',
            'footer-sticky': this.footerType == 'sticky',
            'footer-static': this.footerType == 'static',
          }
        },
        isAppPage() {
          return this.$route.meta.no_scroll
        },
        isThemeDark()     { return this.$store.state.theme == 'dark' },
        layoutTypeClass() { return `main-${this.mainLayoutType}` },
        mainLayoutType()  { return this.$store.state.mainLayoutType  },
        navbarClasses()   {
          return {
            'navbar-hidden'   : this.navbarType == 'hidden',
            'navbar-sticky'   : this.navbarType == 'sticky',
            'navbar-static'   : this.navbarType == 'static',
            'navbar-floating' : this.navbarType == 'floating',
          }
        },
        verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
        windowWidth()          { return this.$store.state.windowWidth },
        activeUserInfo() {return this.$store.state.AppActiveUser}
        
      },      
      methods: {
        updatePanel: function(panel, value) {     
        if (value) {
          document.getElementById(panel).style.backgroundColor = '#006D4E';
          document.getElementById(value).style.backgroundColor = '#4ED176';
        }else{
          document.getElementById(panel).style.backgroundColor = '#006D4E';
          document.getElementById('HomeInmo').style.backgroundColor = '#4ED176';
        }          
        },
        pressElement(value){
          document.getElementById('HomeInmo').style.backgroundColor = '#006D4E';
          document.getElementById('BaseClientes').style.backgroundColor = '#006D4E';
          document.getElementById('Precalifica').style.backgroundColor = '#006D4E';
          document.getElementById('Calculadora').style.backgroundColor = '#006D4E';
                    
          document.getElementById(value).style.backgroundColor = '#4ED176';
          //style="background-color: #4ED176;"
        },
        changeRouteTitle(title) {
          this.routeTitle = title
        },
        updateNavbarColor(val) {
          this.navbarColor = val
          if (val == "#fff") this.isNavbarDark = false
          else this.isNavbarDark = true
        },
        setNavMenuVisibility(layoutType) {
          if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
            this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
            this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
          }
          else {
            this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
          }
        },
        activeLinks() {
         // alert('sí funciona')
      var all_links = document.getElementById("sidebarMenu").getElementsByTagName("a"),
         i=0, len=all_links.length,
         full_path = location.href.split('#')[0]; 
    
      var imprimir = full_path.split('/')[0]+full_path.split('/')[1]+'//'+full_path.split('/')[2]+'/'+full_path.split('/')[3]+'/'+full_path.split('/')[4]
      //alert(imprimir)
    
      for(; i<len; i++) {
          if(all_links[i].href.split("#")[0] == full_path) {
              all_links[i].className += " activee";
          }
      }
      if("https://cotizador.socasesores.com/app/" == full_path) {
       // all_links[0].className += " active";
      // alert('fucniona')
      }
      //alert ("https://cotizador.socasesores.com/app/imprimir" + '==' + imprimir) 
     // if("https://cotizador.socasesores.com/app/imprimir" == imprimir) {
    
      // all_links[0].className += "impFavclass";
       //alert('fucniona')
      //}
      
    
    }
      },
      mounted(){
        if(!JSON.parse(localStorage.getItem('userInfo'))){
          this.$router.push('/login').catch(() => {})
        }
        this.activeLinks()
        
      },
      created() {
        const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
        this.updateNavbarColor(color)
        this.setNavMenuVisibility(this.$store.state.mainLayoutType)
      },
     
    }    
    </script>
    
    
<style scoped>
.view{
  background-color: #fff;
}
.show {
    display: block;
}
.dropdown-menu.show {
    display: block;
}
.dropdown-menu {
    position: absolute;
    z-index: 1000;
    display: none;
    min-width: 10rem;
    padding:0px;
    margin: 0;
    font-size: 1rem;
    color: #fff;
    text-align: left;
    list-style: none;
    background-color: transparent;
    background-clip: padding-box;
    border: none;
    border-radius: 0.25rem;
}
.btn-sublink{
    margin-left: 20px;
    margin-right: auto;
    padding: 0px 8px ;
    cursor: pointer;
    border: none;
    background-color: transparent;
    color:#fff;
}

.show {display: block;}
@media print {
  .vx-navbar-wrapper{
  display: none;
}

    #sidebarMenu, .header{
      display: none;
    }
  
  .wrap-all-the-things{  
    padding:0px;
  }     
  @page{
    
        margin:.5% 1%;
      }
}
body{
  background-color: #F1F4FF !important;
}

.logo-position:hover{
    border:	#006D4E 2px solid;
    border-radius: 5px;    
}

.fa {
position: relative;
display: table-cell;
width: 60px;
height: 36px;
text-align: center;
vertical-align: middle;
font-size:20px;
}


.main-menu:hover,nav.main-menu.expanded {
width:250px;
overflow:visible;
}

.main-menu {
background:#006D4E;
border-right:1px solid #e5e5e5;
position:fixed;
top:0;
bottom:0;
height:100%;
left:0;
width:60px;
overflow:hidden;
-webkit-transition:width .05s linear;
transition:width .05s linear;
-webkit-transform:translateZ(0) scale(1,1);
z-index:1000;
}

.main-menu>ul {
margin:7px 0;
}

.main-menu li {
position:relative;
display:block;
width:250px;
}

.main-menu li>a {
position:relative;
display:table;
border-collapse:collapse;
border-spacing:0;
color:#fff;
 font-family: arial;
font-size: 14px;
text-decoration:none;
-webkit-transform:translateZ(0) scale(1,1);
-webkit-transition:all .1s linear;
transition:all .1s linear;
  
}

.main-menu .nav-icon {
position:relative;
display:table-cell;
width:60px;
height:36px;
text-align:center;
vertical-align:middle;
font-size:18px;
}

.main-menu .nav-text {
position:relative;
display:table-cell;
vertical-align:middle;
width:190px;
  font-family: 'Titillium Web', sans-serif;
}

.main-menu>ul.logout {
position:absolute;
left:0;
bottom:0;
}

.no-touch .scrollable.hover {
overflow-y:hidden;
}

.no-touch .scrollable.hover:hover {
overflow-y:auto;
overflow:visible;
}

a:hover,a:focus {
text-decoration:none;
}

nav {
-webkit-user-select:none;
-moz-user-select:none;
-ms-user-select:none;
-o-user-select:none;
user-select:none;
}

nav ul,nav li {
outline:0;
margin:0;
padding:0;
}
.main-menu li:hover>a,nav.main-menu li.active>a,.dropdown-menu>li>a:hover,.dropdown-menu>li>a:focus,.dropdown-menu>.active>a,.dropdown-menu>.active>a:hover,.dropdown-menu>.active>a:focus,.no-touch .dashboard-page nav.dashboard-menu ul li:hover a,.dashboard-page nav.dashboard-menu ul li.active a {
color:#fff;
background-color:#4ED176;
}
.area {
float: left;
background: #e2e2e2;
width: 100%;
height: 100%;
}

.overlay {
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  color: #f1f1f1; 
  width: 100%;
  transition: .5s ease;
  opacity:0;
  color: white;
  font-size: 20px;
  padding: 20px;
  text-align: center;
}
.main-menu:hover .overlay {
  opacity: 1;
}
.header-Co-brand{
  width: 162px;
  height: 71px;
  object-fit: contain;
}

.alinear-logos{
  display: flex;
  flex-direction: column;
  justify-content: center;
}


/***** Estilos responsivos para el MENU MOBILE ****/
.movilBtnMenuInmob {
  position: fixed;
  top: 34px;
}

#movilMenu.main-menu {
  display: block;
}

.navbarInmob {
  padding-left: 3.5rem;
}

.navbarInmob .logo-position {
  padding-right: 16px;
}

.headerLogoInmob {
  width: 100%;
}

.headerLogoInmob .alinear-logos {
  max-width: 199px;
  cursor: pointer;
}

.headerLogoInmob img {
  width: 100%;
}

.headerLogoFraseInmob {
  display: block;
  width: 100%;
  max-width: 227px;
  height: auto;
  margin-left: 6rem;
  margin-top: .5rem;
  margin-bottom: .5rem;
  /*height: 17px;*/
}

@media screen and (max-width:896px) {
  .main-menu  {
    display: none;
    padding-top: 64px;
  }

  .navbarInmob {
    padding-left: 16px;
  }

  .navbarInmob .logo-position {
    margin-left: 0;
  }

  .inmobContent .vx-navbar-wrapper {
    z-index: 300;
  }

  .movilBtnMenuInmob {
    z-index: 600;
  }

  .mainMenuInmob {
    z-index: 500;
  }
}

@media screen and (max-width: 656px) {
  .navbarInmob .perfil, .navbarInmob .logo-position {
    max-width: 50%;
  }

  .headerLogoFraseInmob {
    margin-top: 0;
    margin-left: 0;
  }
}

@media screen and (max-width: 575px) {
  .navbarInmob .perfil, .navbarInmob .logo-position {
    max-width: none;
  }
}

@media screen and (max-width: 360px) {
  .movilBtnMenuInmob {
    top: 29px;
  }

  .headerLogoInmob img {
    height: 61px;
  }
}

@media screen and (max-height: 320px) {
  .main-menu {
    overflow-y: auto;
  }
}

@media print {
  /**** Ocultar menú en print****/
  #movilMenu.main-menu {
    display: none;
  }
}
</style>



<!--<script type="text/javascript" src="https://unpkg.com/chart.js-plugin-labels-dv/dist/chartjs-plugin-labels.min.js"></script>*/-->
